
//
const tabComponents = document.querySelectorAll('.tabs');

//
if (tabComponents !== null) {
    for (const tabComponent of tabComponents) {

        const tabs = tabComponent.querySelectorAll('.tab-label')
        if (tabs !== null) {
            for (const thisTab of tabs) {
                thisTab.addEventListener('click', (event) => {
                    for (const otherTab of tabs) {
                        otherTab.removeAttribute('data-open');
                    }
                    thisTab.setAttribute('data-open', 'data-open');
                });
            }
        }

    }
}